var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPhotoEpDsk(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "16px",
    viewBox: "0 0 20 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icPhotoEpDsk") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10,6.36363636 C8.49363636,6.36363636 7.27272727,7.58509091 7.27272727,9.09090909 C7.27272727,10.5972727 8.49363636,11.8181818 10,11.8181818 C11.506,11.8181818 12.7272727,10.5972727 12.7272727,9.09090909 C12.7272727,7.58509091 11.506,6.36363636 10,6.36363636 Z M18,2.98295455 L15.6,2.98295455 C15.27,2.98295455 14.9144,2.72840909 14.8102,2.41698864 L14.1898,0.565767045 C14.0852,0.254545455 13.73,0 13.4,0 L6.6,0 C6.27,0 5.9144,0.254545455 5.8102,0.565965909 L5.1898,2.4171875 C5.0852,2.72840909 4.73,2.98295455 4.4,2.98295455 L2,2.98295455 C0.9,2.98295455 0,3.87784091 0,4.97159091 L0,13.9204545 C0,15.0142045 0.9,15.9090909 2,15.9090909 L18,15.9090909 C19.1,15.9090909 20,15.0142045 20,13.9204545 L20,4.97159091 C20,3.87784091 19.1,2.98295455 18,2.98295455 Z M10,14.0909091 C7.2386,14.0909091 5,11.8523091 5,9.09090909 C5,6.32970909 7.2386,4.09090909 10,4.09090909 C12.761,4.09090909 15,6.32970909 15,9.09090909 C15,11.8523091 12.761,14.0909091 10,14.0909091 Z M17.5,6.36363636 C17.1236364,6.36363636 16.8181818,6.05857143 16.8181818,5.68181818 C16.8181818,5.30545455 17.1236364,5 17.5,5 C17.8767532,5 18.1818182,5.30545455 18.1818182,5.68181818 C18.1818182,6.05857143 17.8765584,6.36363636 17.5,6.36363636 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop-Manage-Photos",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icPhotoEpDsk",
    fill: "#666666",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPhotoEpDsk);
export default __webpack_public_path__ + "static/media/icPhotoEpDsk.9246e6fec0b365ef6103f9a329324e0f.svg";
export { ForwardRef as ReactComponent };